import React, { useEffect, useState } from "react";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import { Link } from "react-router-dom";
import HomeHeader from "../component/HomeHeader";
import AOS from "aos";
import "aos/dist/aos.css";

const homeURL = "https://thrive-mqy3.onrender.com/v1/contactus";

function Home() {
  useEffect(() => {
    AOS.init();
  }, []);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sendContactData = async (e) => {
    e.preventDefault();

    try {
      const contactDetails = {
        name,
        email,
        message,
      };
      console.log("ContactQuestion", contactDetails);
      const contactData = {
        method: "POST",
        body: JSON.stringify(contactDetails),
        headers: { "Content-Type": "application/json" },
      };

      const response = await fetch(homeURL, contactData);
      const data = await response.json();
      console.log("data", data);
    } catch (error) {
      console.log("something went wrong" + error);

      return;
    }
  };
  return (
    <div>
      <HomeHeader />
      <div className="relative min-h-[20vh] overflow-hidden">
        <img
          src="https://img.freepik.com/free-photo/medium-shot-women-enjoying-blue-matcha-home_23-2150687547.jpg?size=626&ext=jpg&uid=R99483108&ga=GA1.1.148381924.1699598539&semt=sph"
          alt="homebg"
          className="w-full h-[80vh] object-cover"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.6)] z-1">
          <div className="relative top-[30%] w-fit mx-auto text-center pb-12">
            <h1 className="text-white font-semibold text-6xl uppercase mb-2">
              Nurturing Mind
            </h1>
            <h1 className="text-white font-semibold text-6xl uppercase">
              Embracing Wellness
            </h1>
            <p className="text-white text-xl mt-4 mb-12">
              Reclaim your mental well-being and live a life filled with purpose
              and joy.
              <br /> Start your transformative journey today.
            </p>
            <Link to="/signup">
              <button
                className="bg-[#295700] text-white text-2xl block w-fit mx-auto px-12 py-2 mt-6 rounded-md font-semibold "
                data-aos="fade-up"
                data-aos-delay="50"
                data-aos-duration="5000"
              >
                Get Started
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="bg-white  py-8 border-b border-green-500">
        <div className="w-[80%] mx-auto">
          <h1 className="text-3xl text-center font-bold text-[#295700] py-8 uppercase">
            About Us
          </h1>
          <div className="flex flex-col gap-4 md:flex-row md:justify-center md:gap-8">
            <img
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1700696671/close-up-young-colleagues-hands-meeting_ft2xwj.jpg"
              alt="about image"
              className="object-cover rounded-full w-72 h-72 -translate-y-6"
            />
            <div className="w-2/3">
              <p className="text-[#295700] text-lg ">
                Welcome to thrive Your Path to Emotional Wellness, Empowering
                You for a Balanced Life, Life's challenges can sometimes take a
                toll on our mental well-being. At thrive we believe that
                everyone deserves the tools to nurture their emotional health
                and lead a fulfilling life. thrive is designed to guide you on a
                journey of self-discovery, resilience, and positivity.
              </p>
              <Link to="/about">
                <button className="block mt-8 mb-4 md:mb-8 w-fit px-12 py-2 rounded bg-[#295700] text-white font-semibold relative left-20">
                  READ MORE
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#D4DDCC] px-6 text-[#295700]">
        <h1 className="text-center font-bold text-3xl pt-12 pb-6 text-[#295700]">
          WHY US?
        </h1>
        <p className="text-center text-lg">
          Take a step towards better mental well-being with or app designed to
          support you on your journey.
        </p>
      </div>
      <div className="bg-[#D4DDCC] ">
        <div className="bg-[#D4DDCC] py-16 flex flex-col gap-6 md:grid grid-cols-3 md:justify-center md:w-[70%] md:mx-auto">
          <div
            className="bg-white py-4 flex flex-col items-center gap-4 w-4/5 md:w-full mx-auto rounded-lg shadow-lg"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <div className="w-[90px] h-[90px] flex items-center justify-center rounded-full bg-[#D4DDCC]">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518532/dikl7x0jvydzkvtrmjuy.svg"
                alt="privacy"
                className="scale-75"
              />
            </div>
            <h2 className="text-green-700 font-semibold">PRIVACY</h2>
            <p className="text-[#295700] px-6 mb-12 text-center text-lg">
              We ensure that our digital footprint and sensitive data data
              remain protected from unwanted surveillance
            </p>
          </div>
          <div
            className="bg-[#DCAE96] py-4 flex flex-col items-center gap-4 w-4/5 md:w-full mx-auto rounded-lg shadow-lg"
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1500"
          >
            <div className="w-[90px] h-[90px] flex items-center justify-center rounded-full bg-[#D4DDCC]">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700517700/fjsjin4ull8ls4a1hsav.svg"
                alt="community"
                className="scale-[85%]"
              />
            </div>
            <h2 className="text-white font-semibold">COMMUNITY</h2>
            <p className="text-white px-6 mb-6 text-center text-lg">
              Our community support brings people together providing helps,
              resources and encouragement for collective growth
            </p>
          </div>
          <div
            className="bg-white py-4 flex flex-col items-center gap-4 w-4/5 md:w-full mx-auto rounded-lg shadow-lg"
            data-aos="fade-left"
            data-aos-anchor="#example-anchor"
            data-aos-offset="500"
            data-aos-duration="500"
          >
            <div className="w-[90px] h-[90px] flex items-center justify-center rounded-full bg-[#D4DDCC]">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518821/bbiah79hxlo566q4mzkp.svg"
                alt="therapy"
                className="scale-75"
              />
            </div>
            <h2 className="text-[#295700] font-semibold">THERAPY</h2>
            <p className="text-[#295700] px-6 mb-12 text-center text-lg">
              We gice professional help for emotional well-being by addressing
              emotional challenges, gain insights and develop coping strategies
            </p>
          </div>
          <div
            className="bg-[#DCAE96] py-4 flex flex-col items-center gap-4 w-4/5 md:w-full mx-auto rounded-lg shadow-lg"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <div className="w-[90px] h-[90px] flex items-center justify-center rounded-full bg-[#D4DDCC]">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518775/ptkgxwovgjn9o35mdht4.svg"
                alt="relaxation"
                className="scale-75"
              />
            </div>
            <h2 className="text-white font-semibold">RELAXATION</h2>
            <p className="text-white px-6 mb-12 text-lg">
              We ensure that our digital footprint and sensitive data remain
              protected from unwanted surveillance
            </p>
          </div>
          <div
            className="bg-white py-4 flex flex-col items-center gap-4 w-4/5 md:w-full mx-auto rounded-lg shadow-lg"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1500"
          >
            <div className="w-[90px] h-[90px] flex items-center justify-center rounded-full bg-[#D4DDCC]">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518899/kz7pzpy6pxktlaycxqqr.svg"
                alt="user_center"
                className="scale-75"
              />
            </div>
            <h2 className="text-green-700 font-semibold">USER CENTERED</h2>
            <p className="text-[#295700] px-6 mb-6 text-center text-lg">
              Our application prioritizes the user interface as well as the ...
            </p>
          </div>
          <div
            className="bg-[#DCAE96] py-4 flex flex-col items-center gap-4 w-4/5 md:w-full mx-auto rounded-lg shadow-lg"
            data-aos="fade-left"
            data-aos-anchor="#example-anchor"
            data-aos-offset="500"
            data-aos-duration="500"
          >
            <div className="w-[90px] h-[90px] flex items-center justify-center rounded-full bg-[#D4DDCC]">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700517611/qopsnkt8kytxytjwf1nd.svg"
                alt="user_center"
                className="scale-75"
              />
            </div>
            <h2 className="text-white font-semibold">ARTICLE</h2>
            <p className="text-white px-6 mb-6 text-center text-lg">
              Discover practical tips, expert advice and the latest trend in
              mental wellness to help you n...
            </p>
          </div>
        </div>
      </div>
      <div className="pt-6 pb-12 px-8 border-b border-green-500">
        <h1 className="text-center font-bold text-3xl text-[#295700] py-6">
          OUR THERAPISTS
        </h1>
        <div className="flex flex-col gap-6 md:gap-6 md:w-[60%] md:mx-auto md:flex-row md:justify-center">
          <div className="flex flex-col items-center gap-2 bg-[#D4DDCC] border border-green-500 py-12 md:w-full  rounded-md">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518381/wpsb6algghuo37iknspy.png"
              alt="musa"
              className="w-28 h-28"
            />
            <h2 className="text-green-700 font-semibold text-3xl text-center">
              M. MUSA
            </h2>
            <p className="text-[#295700]">Senior At Therapy</p>
          </div>
          <div className="flex flex-col items-center gap-2 bg-[#D4DDCC] border border-green-500 py-12 md:w-full rounded-md">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1700517460/wvewtwpkvveokp9pda3k.png"
              alt="aisha"
              className="w-28 h-28"
            />
            <h2 className="text-green-700 font-semibold text-3xl">S. AISHA</h2>
            <p className="text-[#295700]">Senior At Therapy</p>
          </div>
        </div>
        <Link to="/therapistapplication">
          <button className="block w-fit mx-auto mt-8 px-6 py-2 rounded-md bg-[#295700] text-white font-semibold">
            APPLY AS A THERAPIST
          </button>
        </Link>
      </div>
      <div className="bg-[#D4DDCC] py-4 border-b border-green-500">
        <h1 className="text-center font-bold text-3xl text-[#295700] py-6">
          OUR COMMUNITY
        </h1>
        <p className="mt-6 text-center text-[#295700] mb-4 w-[70%] mx-auto text-lg">
          Join a supportive community. Connect with a community of like-minded
          individuals who are on their own paths to emotional wellness. Share
          your experiences, learn from others, and find comfort in knowing
          you're not alone.
        </p>
        <img
          src="https://res.cloudinary.com/druryt8ny/image/upload/v1700517722/fhrhrzzgow8v8wssv5i4.svg"
          alt="communitymain"
          className="w-full md:w-[75%] object-cover mx-auto md:rounded-md"
        />
        <Link to="/community">
          <button className="block w-fit mx-auto px-6 py-2 rounded-md bg-[#295700] text-white font-semibold mt-4 md:mb-8">
            JOIN NOW
          </button>
        </Link>
      </div>
      <div className="bg-[#D4DDCC] py-4 border-b border-green-500">
        <h1 className="text-center font-bold text-3xl text-[#295700] py-6">
          RESOURCES
        </h1>
        <p className="text-[#295700] pt-2 pb-6 text-center px-6 text-lg">
          Our resources can provide you with valuable information, tools and
          references to enhance your mental well-being, which includes:
        </p>
        <div className="relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full z-10">
            <img
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1700577180/signIn%20images/sign_in_image_nwrvyo.jpg"
              alt="resourcesmain"
              className="w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.3)] z-30" />
          <div className="relative z-40 pb-6">
            <div className="grid grid-cols-2 justify-center gap-8 px-12 pt-12 pb-6">
              <button className="block px-6 py-2 bg-white text-[#295700] rounded-md">
                Exercise
              </button>
              <button className="block px-6 py-2 bg-white text-[#295700] rounded-md">
                Riddles and Jokes
              </button>
            </div>
            <div className="flex px-12">
              <button className="block w-full py-2 text-center bg-white text-[#295700] rounded-md">
                Video &amp; Audio Resources
              </button>
            </div>
            <div className="grid grid-cols-2 justify-center gap-8 px-12 pt-6 pb-8">
              <button className="block px-6 py-2 bg-white text-[#295700] rounded-md">
                Self-Help Guides
              </button>
              <button className="block px-6 py-2 bg-white text-[#295700] rounded-md">
                Educational Materials
              </button>
            </div>
            <div className="flex px-12">
              <button className="block w-full py-2 text-center bg-white text-[#295700] rounded-md">
                Online Support Communities
              </button>
            </div>
            <Link to="/mainresources">
              <button className="block w-fit mx-auto px-6 py-2 bg-[#295700] text-white font-semibold mt-4 rounded-md">
                View Resources
              </button>
            </Link>
          </div>
        </div>
        <div className="pt-16 pb-28 border-b border-green-500">
          <h1 className="text-3xl text-center text-[#295700] font-bold mb-10">
            TESTIMONIAL
          </h1>
          <div className="md:flex gap-8 justify-center items-start md:w-[80%] md:mx-auto md:gap-6 px-4">
            <div className="flex flex-col gap-6 bg-white pt-4 pb-8 shadow-md mb-6 md:mb-0 rounded-md">
              <div className="py-2">
                <p className="px-6 text-[#295700] text-lg text-center">
                  Thrive has been a game changer for me! The mindfulness
                  exercises and guided meditation sessions have helped me manage
                  my stress and anxiety better. The user-friendly interface
                  makes it easy to navigate, and I appreciate the personalized
                  recommendations based on my progress.
                </p>
              </div>
              <div className="self-end px-6">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1700517656/vq8xp54sh4gmykzqor9o.svg"
                  alt="chidimma"
                  className="w-12 h-12 rounded-full"
                />
              </div>
            </div>
            <div className="flex flex-col gap-6 bg-white pt-4 pb-8 shadow-md mb-6 md:mb-0 rounded-md">
              <div className="py-2">
                <p className="px-6 text-[#295700] text-lg text-center">
                  Thrive has been instrumental in destigmaztizing therapy for
                  me. The on-demand video therapy sessions have been a
                  lifesaver, especailly during times when I couldn't make it to
                  in-person appointments. The licensed therapises are
                  compassionated and understanding.
                </p>
              </div>
              <div className="self-end px-6">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518701/foexwrczolfqaeqy8pu0.svg"
                  alt="rahmat"
                  className="w-12 h-12 rounded-full"
                />
              </div>
            </div>
            <div className="flex flex-col gap-6 bg-white pt-4 pb-8 shadow-md mb-6 md:mb-0 rounded-md">
              <div className="py-2">
                <p className="px-6 text-[#295700] text-lg text-center">
                  Thrive has been instrumental in destigmaztizing therapy for
                  me. The on-demand video therapy sessions have been a
                  lifesaver, especailly during times when I couldn't make it to
                  in-person appointments. The licensed therapises are
                  compassionated and understanding.
                </p>
              </div>
              <div className="self-end px-6">
                <img
                  src="https://res.cloudinary.com/deofacwik/image/upload/v1694602402/doctor3_qsthef.jpg"
                  alt="oladoja"
                  className="w-12 h-12 rounded-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#D4DDCC] py-10 px-8">
          <h1 className="text-3xl font-bold text-center text-[#295700] pt-4 mb-4 uppercase">
            Contact Us
          </h1>
          <p className="text-[#295700] text-center text-lg pt-2 mb-6">
            We value your input! We respond without delay.
          </p>
          <form className="mt-4 flex flex-col gap-4 md:w-[50%] md:mx-auto">
            <input
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="Name"
              className="px-4 py-2 border border-slate-200 block w-full rounded-[5px]"
            />
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              placeholder="Email"
              className="px-4 py-2 border border-slate-200 block w-full rounded-[5px]"
            />
            <input
              onChange={(e) => setMessage(e.target.value)}
              type="text"
              placeholder="Message"
              className="px-4 py-2 border border-slate-200 block w-full rounded-[5px] h-40"
            />
            <button
              onClick={sendContactData}
              className="bg-[#295700] text-white font-semibold uppercase py-1 rounded-md"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      <Footer />
      <script src="https://unpkg.com/aos@next/dist/aos.js"></script>
      <script>AOS.init()</script>
    </div>
  );
}

export default Home;
